import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colorPalette } from '@qualifio/ui-commons';
import { useTranslation } from 'react-i18next';
import { MarkerProps } from './types';
import { programAccessIcon } from '../icons';

export const deniedMemberColor = colorPalette.red.main;

export function DeniedMemberMarker({
  size = 'sm',
  sx,
  tooltipProps,
  ...props
}: MarkerProps): React.ReactElement {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('markers.denied-member')} placement="top" mode="title" {...tooltipProps}>
      <Box
        component={FontAwesomeIcon}
        icon={programAccessIcon}
        color={deniedMemberColor}
        size={size}
        sx={sx}
        {...(props as any)}
      />
    </Tooltip>
  );
}
